import { render, staticRenderFns } from "./DoctorMe.vue?vue&type=template&id=2f1827fe&scoped=true"
import script from "./DoctorMe.vue?vue&type=script&lang=js"
export * from "./DoctorMe.vue?vue&type=script&lang=js"
import style0 from "./DoctorMe.vue?vue&type=style&index=0&id=2f1827fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1827fe",
  null
  
)

export default component.exports